import React, { useContext } from 'react'
import Skeleton from '@material-ui/lab/Skeleton'

import GreenCircleArrow from 'components/CommonUI/svgIcons/GreenCircleArrow'
import WhiteBlockWraper from 'components/CommonUI/WhiteBlockWraper/WhiteBlockWraper'
import { hex } from 'utils/hex'

import { FetchingContext } from 'components/TopTotalInfo/TopTotalInfo'

const TotalInfoCard = ({
  iconComponent: Icon,
  value = null,
  unit = '',
  color = '#000000',
  className = '',
  title = '',
  percent = null,
}) => {
  const isFetching = useContext(FetchingContext)

  return (
    <WhiteBlockWraper className={`total_info_card_container ${className}`}>
      <div
        className="total_info_card_icon_container"
        style={{ backgroundColor: hex(color) }}
      >
        <Icon style={{ color }} />
      </div>
      <div className="total_info_card_content">
        <span className="total_info_card_title_container">
          <span className="total_info_card_title">{title}</span>
          {percent && (
            <span className="percent">
              <GreenCircleArrow />
              <span className="percent_text">{percent}</span>
            </span>
          )}
        </span>
        <span className="total_info_card_value">
          {isFetching ? (
            <Skeleton className="value" variant="text" width={80} />
          ) : (
            <span className="value">{value}</span>
          )}
          <span className="unit">{unit}</span>
        </span>
      </div>
    </WhiteBlockWraper>
  )
}

export default TotalInfoCard
